import React, {FC, ReactNode, useState} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DecisionTreeModel} from '../../../../../libs/shared/core/src/models/api/decisionTrees/decisionTreeModel';
import {TextBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {OkCancelDialog} from '../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';

/*
 * Types.
 */

type ChatBotSubtreeNameDialogProps = {
  title: ReactNode;
  okButtonLabel: ReactNode;
  subtrees: ReadonlyArray<DecisionTreeModel>;
  onOkClick: (arg: string) => Promise<void>;
  onCancelClick: () => void;
};

/*
 * Component.
 */

export const ChatBotSubtreeNameDialog: FC<ChatBotSubtreeNameDialogProps> = ({
  title,
  okButtonLabel,
  onOkClick,
  onCancelClick,
}) => {
  const [subtreeName, setSubtreeName] = useState('');
  const [hasDuplicateNameError, setHasDuplicateNameError] = useState(false);
  const onSubmit = async () => {
    try {
      await onOkClick(subtreeName.trim());
    } catch (error) {
      if (error?.reason?.includes('different name')) {
        setHasDuplicateNameError(true);
      }
    }
  };

  return (
    <OkCancelDialog
      width={300}
      title={title}
      onRequestClose={onCancelClick}
      okButtonLabel={okButtonLabel}
      onOkClick={onSubmit}
      isOkDisabled={subtreeName.trim().length === 0}
    >
      <TextBox
        value={subtreeName}
        onChange={setSubtreeName}
        hasError={hasDuplicateNameError}
        label={<Trans id="chatbot-subtree-create-dialog-label">Name</Trans>}
        isRequired
        errorMessage={
          <Trans id="chatbot-subtree-create-dialog-error-message">
            A flow with this name already exists.
          </Trans>
        }
      />
    </OkCancelDialog>
  );
};
